module.exports = __webpack_public_path__ + "static/media/gen_saf_sto.5cb36390.png";